<template>
  <div class="dashboard-content">
    <div id="slide-reveal-overlay" v-on:click="closeSlideBar()" style="display: none; position: fixed; top: 0px; left: 0px; height: 100%; width: 100%; z-index: 1048; background-color: rgba(0, 0, 0, 0.5);"></div>
    <div class="container">
      <div class="row">
        <div class="col-xl-8 col-lg-8 col-md-6 col-sm-12 col-12">
          <div class="dashboard-page-header" v-if="tutor">
            <h3 class="dashboard-page-title" v-if="tutor.name">{{tutor.name}}</h3>
            <p class="d-block mb-0">View &amp; Edit Tutor Details</p>
          </div>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12">
          <div>
            <ul>
              <li class="d-flex justify-content-between align-items-center">
                Activate Profile
                <div class="switch-notification" v-if="tutor">
                  <label class="switch">
                    <input type="checkbox" id="activate-profile" @click="activateTutor" :checked="this.tutor.is_active=='Y'?true:false">
                    <span class="slider"></span>
                  </label>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xl-12 col-lg-10 col-md-9 col-sm-12 col-12">
          <div class="dashboard-page-header">
            <a class="btn btn-sm mr-1" :class="(tab=='profile')?'btn-default':'btn-outline-light'" @click="tab='profile'">Profile</a> 
            <a class="btn btn-sm mr-1" :class="(tab=='timing')?'btn-default':'btn-outline-light'" @click="tab='timing'">Timing</a> 
            <a class="btn btn-sm mr-1" :class="(tab=='salary')?'btn-default':'btn-outline-light'" @click="tab='salary'">Salary</a> 
            <a class="btn btn-sm mr-1" :class="(tab=='bank-details')?'btn-default':'btn-outline-light'" @click="tab='bank-details'">Bank Details</a> 
            <a class="btn btn-sm mr-1" :class="(tab=='payment')?'btn-default':'btn-outline-light'" @click="tab='payment'">Payment</a> 
            <a class="btn btn-sm mr-1" :class="(tab=='settings')?'btn-default':'btn-outline-light'" @click="tab='settings'">Settings</a> 
          </div>
        </div>
      </div>
      <div class="row">
        <Profile :tutor="tutor" v-if="tab=='profile' && tutor" />
        <Timing :tutor="tutor" v-if="tab=='timing' && tutor" />
        <Salary :tutor="tutor" v-if="tab=='salary' && tutor" />
        <BankDetails :tutor="tutor" v-if="tab=='bank-details' && tutor" />
        <Payment :tutor="tutor" v-if="tab=='payment' && tutor" />
        <Setting :tutor="tutor" v-if="tab=='settings' && tutor" />
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
const Profile = () => import(/* webpackPrefetch: true */ "@/components/tutor-details/Profile.vue");
const Timing = () => import(/* webpackPrefetch: true */ "@/components/tutor-details/Timing.vue");
const Salary = () => import(/* webpackPrefetch: true */ "@/components/tutor-details/Salary.vue");
const BankDetails = () => import(/* webpackPrefetch: true */ "@/components/tutor-details/BankDetails.vue");
const Payment = () => import(/* webpackPrefetch: true */ "@/components/tutor-details/Payment.vue");
const Setting = () => import(/* webpackPrefetch: true */ "@/components/tutor-details/Settings.vue");
export default {
  name: "admin-tutor-details",
  components:{
    'Profile' : Profile,
    'Timing' : Timing,
    'Salary' : Salary,
    'BankDetails' : BankDetails,
    'Payment' : Payment,
    'Setting' : Setting,
  },
  data(){
    return {
      tutor: null,
      tab:'profile',
      activate:{
        status: null,
        tutor_id: null
      }
    }
  },
  beforeMount(){
    axios.get(process.env.VUE_APP_TUTION_SITE_API+'/tutor/'+this.$route.params.id,{headers:{"Authorization":'Bearer '+process.env.VUE_APP_GUEST_TOKEN}}).then(res => {
      this.tutor = res.data.data;
      this.activate.status = this.tutor.is_active;
      this.activate.tutor_id = this.tutor.tutor_id;
    });
  },
  methods:{
    closeSlideBar(){
      if(this.tab == 'timing'){
        document.getElementById('slide-panel1').style.right = '-275px';
        document.getElementById('slide-panel1').style.width = '0px';
        document.getElementById('slide-panel2').style.right = '-275px';
        document.getElementById('slide-panel2').style.width = '0px';
        document.getElementById('slide-panel3').style.right = '-275px';
        document.getElementById('slide-panel3').style.width = '0px';
      }
      if(this.tab == 'salary'){
        document.getElementById('slide-panel4').style.right = '-275px';
        document.getElementById('slide-panel4').style.width = '0px';
      }
      if(this.tab == 'payment'){
        document.getElementById('slide-panel5').style.right = '-275px';
        document.getElementById('slide-panel5').style.width = '0px';
      }
      document.getElementById('slide-reveal-overlay').style.display = 'none';
    },
    activateTutor(e){
      e.preventDefault();
      this.activate.status = (document.getElementById('activate-profile').checked == true)?'Y':'N';
        axios.post(process.env.VUE_APP_TUTION_SITE_API+'/tutor_activate',this.activate,{headers:{"Authorization":'Bearer '+(this.$cookies.get('tution-admin').token)}}).then(res => {
          if(res.data.message == 'Tutor updated successfully'){
            this.tutor.is_active = this.activate.status
          }else{
            this.tutor.is_active = (this.activate.status == 'Y')?'N':'Y';
          }
        })
    }
  }
}
</script>

<style scoped>
.switch {
    display: inline-block;
    width: 40px;
    height: 20px;
    transform: translateY(20%);
    position: relative;
}
label {
    display: inline-block;
    max-width: 100%;
    margin-bottom: 5px;
    font-weight: 400;
    font-size: 14px;
    color: #5f5e61;
    line-height: 2.3;
}
.switch input {
    display: none;
}
.slider {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    border-radius: 20px;
    cursor: pointer;
    transition: .4s;
    background: #bdbdbd;
}
.slider:before {
  position: absolute;
  content: "";
  height: 20px;
  width: 20px;
  background-color: white;
  transition: .4s;
  border-radius: 20px;
}
.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}
input:checked + .slider:before {
  transform: translateX(20px);
}
input:checked+.slider {
    background: #129e32;
}
.btn-outline-light:hover {
    color: #2e2f39;
    background-color: #f0f0f8;
    border-color: #f0f0f8;
}
.btn-outline-light {
    color: #2e2f39;
    background-color: transparent;
    border-color: #ebebed;
}
</style>